import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMapPin } = FiIcons;

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-slate-900 text-slate-300" id="contact">
      <div className="h-1 bg-gradient-to-r from-primary via-orange-400 to-yellow-400" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start gap-8">
          {/* Logo & Description */}
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left">
            <div className="mb-4 bg-white/95 px-4 py-3 rounded-xl inline-block shadow-sm">
              <img 
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1773836886799-image.png" 
                alt="MyHomeTutors Logo" 
                className="h-10 object-contain" 
              />
            </div>
            <p className="text-sm text-slate-400 max-w-xs leading-relaxed">
              Lucknow's trusted home tutoring platform connecting students with verified expert tutors since 2009.
            </p>
          </div>

          {/* Quick Contact Chips */}
          <div className="flex flex-col sm:flex-row gap-4 items-center">
            <div className="flex items-center gap-3 bg-slate-800/50 px-5 py-3 border border-slate-700/50">
              <div className="w-10 h-10 bg-slate-800 flex items-center justify-center flex-shrink-0">
                <FiMapPin className="w-4 h-4 text-primary" />
              </div>
              <div className="text-sm">
                <p className="font-semibold text-white">H.N 1/358, Vastu Khand</p>
                <p className="text-slate-400 text-xs mt-0.5">Gomti Nagar, Lucknow</p>
                <p className="text-slate-400 text-xs mt-0.5">Uttar Pradesh 226010</p>
              </div>
            </div>
            <a href="tel:+919415905584"
              className="flex items-center gap-3 bg-slate-800/50 px-5 py-3 border border-slate-700/50 hover:border-primary/50 transition-colors group">
              <div className="w-10 h-10 bg-slate-800 group-hover:bg-primary flex items-center justify-center flex-shrink-0 transition-colors">
                <FiPhone className="w-4 h-4 text-primary group-hover:text-white transition-colors" />
              </div>
              <div className="text-sm">
                <p className="font-semibold text-white group-hover:text-primary transition-colors">Call Us Now</p>
                <p className="text-slate-400 text-xs mt-0.5">+91 - 9415905584</p>
              </div>
            </a>
          </div>
        </div>

        <div className="w-full h-px bg-slate-800 my-8"></div>

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-xs font-medium">
            © {year} MyHome Tutors Lucknow. All rights reserved.
          </p>
          <div className="flex items-center flex-wrap gap-x-6 gap-y-2 justify-center">
            <Link to="/about" className="text-xs text-slate-400 hover:text-white transition-colors font-medium">About Us</Link>
            <Link to="/contact" className="text-xs text-slate-400 hover:text-white transition-colors font-medium">Contact Us</Link>
            <Link to="/privacy-policy" className="text-xs text-slate-400 hover:text-white transition-colors font-medium">Privacy Policy</Link>
            <Link to="/terms-and-conditions" className="text-xs text-slate-400 hover:text-white transition-colors font-medium">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;